import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MailCheckedStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M21.25 11V5.5C21.25 4.80964 20.6904 4.25 20 4.25H4C3.30964 4.25 2.75 4.80964 2.75 5.5V17.5C2.75 18.1904 3.30964 18.75 4 18.75H9.5C9.91421 18.75 10.25 19.0858 10.25 19.5C10.25 19.9142 9.91421 20.25 9.5 20.25H4C2.48122 20.25 1.25 19.0188 1.25 17.5V5.5C1.25 3.98122 2.48122 2.75 4 2.75H20C21.5188 2.75 22.75 3.98122 22.75 5.5V11C22.75 11.4142 22.4142 11.75 22 11.75C21.5858 11.75 21.25 11.4142 21.25 11Z"
				fill="currentColor"
			/>
			<path
				d="M22.335 7.1709L13.2295 11.7236C12.4555 12.1105 11.5445 12.1105 10.7705 11.7236L1.66504 7.1709L2.33496 5.8291L11.4414 10.3818C11.7931 10.5576 12.2069 10.5576 12.5586 10.3818L21.665 5.8291L22.335 7.1709Z"
				fill="currentColor"
			/>
			<path
				d="M15.5303 16.9697C15.2374 16.6768 14.7626 16.6768 14.4697 16.9697C14.1768 17.2626 14.1768 17.7374 14.4697 18.0303L15.5303 16.9697ZM16.5 19L15.9697 19.5303C16.1187 19.6793 16.3235 19.7588 16.534 19.7492C16.7445 19.7397 16.9413 19.642 17.0762 19.4801L16.5 19ZM19.5762 16.4801C19.8413 16.1619 19.7983 15.689 19.4801 15.4238C19.1619 15.1587 18.689 15.2017 18.4238 15.5199L19.5762 16.4801ZM22.75 17.5C22.75 14.3244 20.1756 11.75 17 11.75V13.25C19.3472 13.25 21.25 15.1528 21.25 17.5H22.75ZM17 11.75C13.8244 11.75 11.25 14.3244 11.25 17.5H12.75C12.75 15.1528 14.6528 13.25 17 13.25V11.75ZM11.25 17.5C11.25 20.6756 13.8244 23.25 17 23.25V21.75C14.6528 21.75 12.75 19.8472 12.75 17.5H11.25ZM17 23.25C20.1756 23.25 22.75 20.6756 22.75 17.5H21.25C21.25 19.8472 19.3472 21.75 17 21.75V23.25ZM14.4697 18.0303L15.9697 19.5303L17.0303 18.4697L15.5303 16.9697L14.4697 18.0303ZM17.0762 19.4801L19.5762 16.4801L18.4238 15.5199L15.9238 18.5199L17.0762 19.4801Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MailCheckedStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MailCheckedStrokeIcon;
